import { TextField } from '@mui/material';
import { Controller, type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { usersState } from '../../../entities/users';
import type { User } from '../../../types';
import getFullName from '../../../utils/getFullName';
import { AutocompleteMultiple } from '../../AutocompleteMultiple';
import { UserChip, UserAvatar } from '../../base';
import type { UserEventSettingsInitialValues } from '../lib/formTypes';

type RegisteredByFieldsProps = {
  form: UseFormReturn<UserEventSettingsInitialValues>;
  disabled?: boolean;
};

export const RegisteredByFields = ({ form, disabled }: RegisteredByFieldsProps) => {
  const { t } = useTranslation();
  const users = useRecoilValue(usersState);

  return (
    <Controller
      name='filters.registeredBy'
      control={form.control}
      render={({ field }) => (
        <AutocompleteMultiple
          {...field}
          hidden
          disabled={disabled}
          disableCloseOnSelect
          options={users}
          limitTags={4}
          filterSelectedOptions
          onChange={(_, values) => field.onChange(values === 'all' ? users : values)}
          getOptionLabel={(user: User) => getFullName(user)}
          renderTags={(value, getTagProps) =>
            value.map((user, index) => (
              <UserChip user={user} variant='outlined' size='small' {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => <TextField {...params} label={t('registered-by')} />}
          renderOption={(props, user) => (
            <li {...props}>
              <UserAvatar user={user} sx={{ marginRight: '8px' }} />
              {getFullName(user)}
            </li>
          )}
        />
      )}
    />
  );
};
